import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@rebass/grid'
import Text from '../../atoms/Text'
import Button from '../../atoms/Button'
import Tooltip from '../../atoms/Tooltip'

export const FIND_NEXT_ACTION_QUOTA = 5
const FIND_NEXT_REPLY_MESSAGE = '我仲想搵多個呀～'
const LOCAL_STORAGE_KEY_FIND_NEXT_TOOLTIP_OPENED = 'FIND_NEXT_REPLY_TOOLTIP_OPENED'

const FindNextActionSection = ({ onSendMessage, disabled, username, ...props }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const onCloseTooltip = useCallback(() => {
    setTooltipOpen(false)
    localStorage.setItem(`${username}_${LOCAL_STORAGE_KEY_FIND_NEXT_TOOLTIP_OPENED}`, true)
  }, [username])

  useEffect(() => {
    const tooltipOpened = localStorage.getItem(`${username}_${LOCAL_STORAGE_KEY_FIND_NEXT_TOOLTIP_OPENED}`)
    if (!tooltipOpened) {
      setTooltipOpen(true)
    }
  }, [username])

  return (
    <Flex justifyContent="center" p="1rem" {...props}>
      <Flex flexDirection="column" alignItems="flex-end">
        <div id="find_next_anchor" style={{ width: 60 }} />
        <Button
          palette="secondary"
          onClick={() => onSendMessage(FIND_NEXT_REPLY_MESSAGE)}
          disabled={disabled}
        >
          <Text variant="h3" palette={disabled ? 'white' : 'grayscale'}>仲想搵多個 😎</Text>
        </Button>
        <Text variant="body2" palette="error">(訊息 - {FIND_NEXT_ACTION_QUOTA})</Text>
      </Flex>
      <Tooltip anchorId="find_next_anchor" place="top-start" open={tooltipOpen}>
        <Text palette="white">{'可以保留現有要求繼續搵！\n唔駛重新講一次！'}</Text>
        <Flex justifyContent="flex-end" mt={1}>
          <Button
            palette="grayscale"
            padding="0.25rem 0.5rem"
            onClick={onCloseTooltip}
          >
            <Text palette="white" variant="body2">知道</Text>
          </Button>
        </Flex>
      </Tooltip>
    </Flex>
  )
}

FindNextActionSection.propTypes = {
  onSendMessage: PropTypes.func,
  disabled: PropTypes.bool,
  username: PropTypes.string,
}

FindNextActionSection.defaultProps = {
  onSendMessage: () => {},
  disabled: false,
  username: null,
}

export default FindNextActionSection
